import { ApiServiceError } from '@mobi/account/Utils'
import { addToast, ToastContent } from '@mobi/component-library/Feedback/Toast'
import React from 'react'
import { ProblemResponse } from './api'

export function handleApiErrorNotification(err: Error, defaultErrMsg?: string) {
  if (isError(err)) {
    err.response.json().then((p: ProblemResponse) => {
      if ((p.detail || p.title) && p.requestId) {
        addToast({
          id: p.requestId,
          content: <ToastContent title={p.detail || p.title || defaultErrMsg} icon='error' />,
          isDismissable: true,
        })
      }
    })
  }
}

function isError(item: object): item is ApiServiceError {
  return 'response' in item
}
